import { proxy, subscribe } from "valtio"
import { subscribeKey } from "valtio/utils"
import { playMusic } from "@/common/common"
import { togglePlayFlag } from "@/store/general"

// function init() {
//   let flag = localStorage.getItem("play")
//   if (!flag) {
//     localStorage.setItem(
//       "play",
//       JSON.stringify({
//         playObj: {
//           id: "",
//           picUrl: "",
//           name: "",
//           siname: "",
//           sinameId: "",
//           singer: [],
//           dt: "",
//           url: ""
//         },
//         pbFlag: false,
//         pbList: []
//       })
//     )
//   }
// }
// init()
const playSetup = proxy(
  JSON.parse(localStorage.getItem("play"))
    ? JSON.parse(localStorage.getItem("play"))
    : {
        playObj: {
          id: "",
          picUrl: "",
          name: "",
          siname: "",
          sinameId: "",
          singer: [],
          dt: "",
          url: "",
          fee: 0
        },
        pbFlag: false,
        pbList: []
      }
)

// 上一首
const prevSong = () => {
  let index = playSetup.pbList.findIndex(
    (item) => item.id === playSetup.playObj.id
  )
  if (index === -1) {
    //此时表示播放列表中没有该歌曲，那么我们就从头开始播放
    playMusic(playSetup.pbList[0])
  } else if (index === 0) {
    playMusic(playSetup.pbList[playSetup.pbList.length - 1])
  } else {
    playMusic(playSetup.pbList[index - 1])
  }
}
// 下一首
const nextSong = () => {
  let index = playSetup.pbList.findIndex(
    (item) => item.id === playSetup.playObj.id
  )
  // console.log(index)
  if (index === -1) {
    //此时表示播放列表中没有该歌曲，那么我们就从头开始播放
    playMusic(playSetup.pbList[0])
  } else if (index === playSetup.pbList.length - 1) {
    playMusic(playSetup.pbList[0])
  } else {
    playMusic(playSetup.pbList[index + 1])
  }
}
// 订阅引用数据类型（PS：直接整体更改一个对象是不会触发订阅回调的，只能更改对象中某个属性才会触发，所以store中我才会那样子定义，所有的数据都是双向绑定的所以需要做赋值操作的时候需要注意，要单独拿出来给一个变量再进行赋值操作）
subscribe(playSetup.playObj, () => {
  // console.log(playSetup.playObj)
  let index = playSetup.pbList.findIndex(
    (item) => item.id === playSetup.playObj.id
  )
  // console.log(index)
  let obj = {}
  for (const key in playSetup.playObj) {
    obj[key] = playSetup.playObj[key]
  }
  if (index === -1) playSetup.pbList.unshift(obj)
  togglePlayFlag(true)
})
// 订阅基本数据类型
subscribeKey(playSetup, "pbFlag", () => {
  // console.log("pbFlag发生了改变")
})

subscribe(playSetup, () => {
  localStorage.setItem("play", JSON.stringify(playSetup))
})

export { prevSong, nextSong }

export default playSetup

//valtio-persist 数据持久化可以看一下这个库（目前还未使用）
